import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import isValidMexicanPhone from 'utils/isValidMexicanPhone';
import API from '../../../api/API';
import { isValidCurp } from 'utils/isValidCurp';
import isValidPassword from 'utils/isValidPassword';
import { CardHeader, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#F4136B' },
    background: { default: '#121212', paper: '#1e1e1e' }
  }
})

const Card = styled(MuiCard)(({ theme, wide }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    border: 'none',
    boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
      [theme.breakpoints.up('sm')]: {
    width: wide ? '450px' : '100%',
  },
}));

export default function CardSignUp({login = false, darkMode = false}) {
  const [snackbarState, setSnackbarState] = React.useState({open: false, message: "", status: "info"});
  const navigate = useNavigate();

  const [curpError, setCurpError] = React.useState(false);
  const [curpErrorMessage, setCurpErrorMessage] = React.useState('');
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
  const [nameError, setNameError] = React.useState(false);
  const [nameErrorMessage, setNameErrorMessage] = React.useState('');
  const [lastNameError, setLastNameError] = React.useState(false);
  const [lastNameErrorMessage, setLastNameErrorMessage] = React.useState('');

  const [maternalSurNameError, setMaternalSurNameError] = React.useState(false);
  const [maternalSurNameErrorMessage, setMaternalSurNameErrorMessage] = React.useState('');

  const [telephoneError, setTelephoneError] = React.useState(false);
  const [telephoneErrorMessage, setTelephoneErrorMessage] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  

  const validateInputs = () => {
    const email = document.getElementById('email');
    const curp = document.getElementById('curp');
    const password = document.getElementById('password');
    const name = document.getElementById('name');
    const lastName = document.getElementById('last_name');
    const maternalSurName = document.getElementById('maternal_surname');
    const telephone = document.getElementById('telephone');

    let isValid = true;

    if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
      setEmailError(true);
      //setEmailErrorMessage('Por favor proporciona un correo valido.');
      isValid = false;
    } else {
      setEmailError(false);
      setEmailErrorMessage('');
    }

    if (!isValidCurp(curp.value)) {
      setCurpError(true);
      //setCurpErrorMessage('CURP es invalido.');
    } else {
      setCurpError(false);
      setCurpErrorMessage('');
    }

   const isValidPasswordResponse =  isValidPassword(password.value)

    if (!isValidPasswordResponse.success) {
      setPasswordError(true);
      setPasswordErrorMessage(isValidPasswordResponse.message);
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage('');
      isValid = false
    }

    if (!name.value || name.value.length < 1) {
      setNameError(true);
      //setNameErrorMessage('Nombre es requerido.');
      isValid = false;
    } else {
      setNameError(false);
      setNameErrorMessage('');
    }

    if (!lastName.value || lastName.value.length < 1) {
      setLastNameError(true);
      //setLastNameErrorMessage('Apellido es requerido.');
      isValid = false;
    } else {
      setLastNameError(false);
      setLastNameErrorMessage('');
    }

    if (!maternalSurName.value || maternalSurName.value.length < 1) {
      setMaternalSurNameError(true);
      //setLastNameErrorMessage('Apellido es requerido.');
      isValid = false;
    } else {
      setMaternalSurNameError(false);
      setMaternalSurNameErrorMessage('');
    }

    const isValidMexicanPhoneResponse = isValidMexicanPhone(telephone.value)
    if (!isValidMexicanPhoneResponse.success) {
      setTelephoneError(true);
      setTelephoneErrorMessage(isValidMexicanPhoneResponse.message);
      isValid = false;
    } else {
      setTelephoneError(false);
      setTelephoneErrorMessage('');
    }

    return isValid;
  };

  const handleSubmit = async(event) => {
    event.preventDefault();
    if (nameError || emailError || passwordError || lastNameError||curpError) {
      return;
    }

    const data = new FormData(event.currentTarget);
    
    const requestBody = {
      email: data.get('email'),
      name: data.get('name'),
      last_name: data.get('last_name'),
      telephone: data.get('telephone'),
      password: data.get('password'),
      curp: data.get('curp'),
    };

    const response = await API.postUser(requestBody)

    if(response.status == 200){
        setSnackbarState({open:true, message: response.message, status: "success"})
        navigate('/home');
    }else{
        setSnackbarState({open:true, message: response.message, status: "error"})
    }
  }

   const content = (
        <Card variant="outlined" wide = {login}>
            {login?<CardHeader title={"¡Comienza ya!"}/>:<></>}
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
            >
            <TextField
                required
                fullWidth
                size='small'
                id="email"
                label="your@email.com"
                name="email"
                autoComplete="email"
                variant="outlined"
                error={emailError}
                helperText={emailErrorMessage}
                color={emailError ? 'error' : 'primary'}
            />
            <TextField
                required
                fullWidth
                size='small'
                id="curp"
                label="CURP"
                name="curp"
                autoComplete="curp"
                variant="outlined"
                error={curpError}
                helperText={curpErrorMessage}
                color={curpError ? 'error' : 'primary'}
                />
            <TextField
                autoComplete="name"
                name="name"
                required
                fullWidth
                size='small'
                id="name"
                label="Nombre"
                error={nameError}
                helperText={nameErrorMessage}
                color={nameError ? 'error' : 'primary'}
                />
            <TextField
                autoComplete="last_name"
                name="last_name"
                required
                fullWidth
                size='small'
                id="last_name"
                label="Apellido paterno"
                error={lastNameError}
                helperText={lastNameErrorMessage}
                color={lastNameError ? 'error' : 'primary'}
                />
              <TextField
                autoComplete="maternal_surname"
                name="maternal_surname"
                required
                fullWidth
                size='small'
                id="maternal_surname"
                label="Apellido materno"
                error={maternalSurNameError}
                helperText={ maternalSurNameErrorMessage}
                color={maternalSurNameError ? 'error' : 'primary'}
                />
            <TextField
                autoComplete="telephone"
                name="telephone"
                required
                fullWidth
                size='small'
                id="telephone"
                label="Telefono"
                error={telephoneError}
                helperText={telephoneErrorMessage}
                color={telephoneError ? 'error' : 'primary'}
                />
            <TextField
                required
                fullWidth
                size='small'
                name="password"
                label="Contraseña"
                id="password"
                autoComplete="new-password"
                variant="outlined"
                error={passwordError}
                helperText={passwordErrorMessage}
                color={passwordError ? 'error' : 'primary'}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                    endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                        onClick={handleToggleVisibility}
                        edge="end"
                        aria-label="toggle password visibility"
                        >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                    )
                }}
                />
            <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={validateInputs}
            >
                Registrarse
            </Button>
            </Box>
            {login?
                <>
                    <Divider>
                        
                    <Typography sx={{ color: 'text.secondary' }}>or</Typography>
                    </Divider>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography sx={{ textAlign: 'center' }}>
                        Already have an account?{' '}
                        <Link
                        href="/login"
                        variant="body2"
                        sx={{ alignSelf: 'center' }}
                        >
                        Sign in
                        </Link>
                    </Typography>
                    </Box>
                </>
            :<></>}
        </Card>
    );

    return darkMode ? (
        <ThemeProvider theme={darkTheme}>{content}</ThemeProvider>
    ) : (
        content
    );
}